<template>
  <div class="percentage-container">
    <div :class="fill && 'percentage-background'" class="percentage-bar" :style="{ width: fill ? '100%' : barWidth }">
      <div class="percentage-bar" :style="{ width: fill ? barWidth : '100%', backgroundColor: barColor }"></div>
    </div>
    <span :style="{ color: textColor }">{{ percent + '%' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    barColor: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      required: true,
    },
    percent: {
      type: [Number, String],
      default: 100,
    },
    fill: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    barWidth() {
      let stringPercent = this.percent + '%'
      return stringPercent.replace(',', '.')
    },
  },
}
</script>

<style scoped lang="scss">
.percentage-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
  span {
    font-weight: 600;
    font-size: 14px;
    min-width: 40px;
  }
  .percentage-bar {
    border-radius: 6px;
    height: 12px;
  }
}
.percentage-background {
  background-color: $cinza-l80;
}
</style>
